import clienteHttp from "./ClienteHttps";
//import axios from 'axios';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

//axios.defaults.withCredentials = true;

export async function obtenerMisTurnos(usuarioId) {
    const respuesta = await clienteHttp.get(`/turnos`, {
        headers: { "usuario-id": usuarioId }
    });

    return respuesta.data;
}

    export async function cancelarMiTurno(usuarioId, turnoId, motivoCancelacion) {
        const respuesta = await clienteHttp.delete(`/turnos/${turnoId}`, {
            headers: { 
                "usuario-id": usuarioId 
            },
            data: {
                motivoCancelacion
            }
        });
    
        return respuesta.data;
    }

export async function proponerNuevaFecha(usuarioId, turnoId, fecha, hora) {

    const respuesta = await clienteHttp.patch(`/turnos/${turnoId}/reprogramar`, 
        { fecha, hora },
        { headers: { "usuario-id": usuarioId } }
    );
    return respuesta.data;
}